// The @ownbit/alpinejs alias lets us refer to the local installation of Alpine.js
// while importing from 'alpinejs' is redirected to the 'obConsentManagerAlpine' global
import Alpine from '@ownbit/alpinejs'
window.obConsentManagerAlpine = Alpine
